import React, { useEffect, useState } from 'react';
import API from '../utils/api';

const MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
const purposeLabel = p => ({ general: 'General', cow_adoption: 'Cow Adoption', fodder: 'Fodder', medical: 'Medical', infrastructure: 'Infra', festival: 'Festival' }[p] || p);

export default function ManageDonations() {
  const [donations, setDonations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState({ status: '', month: '', year: new Date().getFullYear() });
  const [total, setTotal] = useState(0);

  const fetchDonations = async () => {
    setLoading(true);
    try {
      const q = new URLSearchParams({ limit: 50, ...Object.fromEntries(Object.entries(filter).filter(([, v]) => v)) });
      const res = await API.get(`/admin/donations?${q}`);
      setDonations(res.data.donations);
      setTotal(res.data.total);
    } catch (err) { console.error(err); }
    setLoading(false);
  };

  useEffect(() => { fetchDonations(); }, [filter]);

  const successTotal = donations.filter(d => d.paymentStatus === 'success').reduce((s, d) => s + d.amount, 0);

  return (
    <div>
      <h2 className="admin-page-title">💰 Donation Records</h2>

      <div style={{ display: 'flex', gap: 12, marginBottom: 20, flexWrap: 'wrap', alignItems: 'center' }}>
        <select className="form-select" style={{ width: 160 }} value={filter.status} onChange={e => setFilter(p => ({ ...p, status: e.target.value }))}>
          <option value="">All Statuses</option>
          <option value="success">✅ Success</option>
          <option value="pending">⏳ Pending</option>
          <option value="failed">❌ Failed</option>
        </select>
        <select className="form-select" style={{ width: 130 }} value={filter.month} onChange={e => setFilter(p => ({ ...p, month: e.target.value }))}>
          <option value="">All Months</option>
          {MONTHS.map((m, i) => <option key={i} value={i + 1}>{m}</option>)}
        </select>
        <select className="form-select" style={{ width: 110 }} value={filter.year} onChange={e => setFilter(p => ({ ...p, year: e.target.value }))}>
          {[2024, 2025, 2026, 2027].map(y => <option key={y} value={y}>{y}</option>)}
        </select>
        <div style={{ marginLeft: 'auto', fontWeight: 700, color: 'var(--saffron)', fontSize: '1.1rem' }}>
          Total (Success): ₹{successTotal.toLocaleString('en-IN')} | Records: {total}
        </div>
      </div>

      {loading ? <div className="loader"><div className="spinner" /></div> : (
        <div className="admin-table">
          <table>
            <thead><tr>
              <th>Date</th><th>Name</th><th>Email / Mobile</th><th>Amount</th><th>Purpose</th><th>Status</th><th>Receipt</th>
            </tr></thead>
            <tbody>
              {donations.map(d => (
                <tr key={d._id}>
                  <td style={{ fontSize: '0.82rem' }}>{new Date(d.createdAt).toLocaleDateString('en-IN')}</td>
                  <td>{d.user?.name || d.guestName || '—'}</td>
                  <td style={{ fontSize: '0.82rem' }}>{d.guestEmail || d.user?.email || ''}<br />{d.guestMobile || d.user?.mobile || ''}</td>
                  <td style={{ fontWeight: 700, color: 'var(--saffron)' }}>₹{d.amount?.toLocaleString('en-IN')}</td>
                  <td>{purposeLabel(d.purpose)}</td>
                  <td><span className={`donation-item-status status-${d.paymentStatus}`}>{d.paymentStatus}</span></td>
                  <td style={{ fontSize: '0.8rem', color: '#888' }}>{d.receiptNumber || '—'}</td>
                </tr>
              ))}
              {donations.length === 0 && <tr><td colSpan={7} style={{ textAlign: 'center', padding: 32, color: '#888' }}>No donations found</td></tr>}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
